export default __webpack_public_path__ + "static/Right_Faded_BW-c4626efbe8b0eca579fd333beb210727.jpg";